import { FC } from 'react'

import styled from 'styled-components'

import Empty from 'src/Assets/Svg/common/empty.svg?react'
import { variables } from 'src/Styled/variables'

export const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`

const Text = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const EmptyListMessage: FC = () => (
  <Container>
    <Empty />
    <Text>You haven't invited any artists yet</Text>
  </Container>
)
